export const SET_LOGGED_IN_USER = "SET_LOGGED_IN_USER";
export const SET_THEME = "SET_THEME";
export const SET_PAGE_TITLE = "SET_PAGE_TITLE";
export const SET_STATUS_BAR_MESSAGE = "SET_STATUS_BAR_MESSAGE";
export const LOG_IN = "USER_LOG_IN";
export const LOG_IN_COMPLETED = "USER_LOG_IN_COMPLETED";